import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  Accordion,
  AccordionDetails,
  AccordionStack,
  AccordionSummary,
} from 'base-ui'

import { productAccessorGetSubstances } from '../../../model/productAccessor/productAccessorGetSubstances'
import { productAccessorIsRxOrOtxTemplate } from '../../../model/productAccessor/productAccessorIsRxOrOtxTemplate'
import { useProductPageContext } from '../../productPageContext'
import { ProductDescriptionDocumentLinks } from '../ProductDescriptionDocumentLinks'
import { ProductDescriptionIngredientsSection } from '../ProductDescriptionIngredients/ProductDescriptionIngredientsSection'
import { ProductDescriptionSection } from '../ProductDescriptionSection'
import { ProductDescriptionShowMore } from '../ProductDescriptionShowMore'
import { useProductDescriptionSections } from '../useProductDescriptionSections'

export const ProductDescriptionOldLayout: FC = () => {
  const { product, productTemplate } = useProductPageContext()
  const { additionalInformation, descriptionLong } =
    useProductDescriptionSections()
  const descriptionLongAndAdditionalInformation = [
    ...(descriptionLong ?? []),
    ...(additionalInformation ?? []),
  ]
  const { activeSubstances, additiveSubstances } =
    productAccessorGetSubstances(product)

  return (
    <>
      <ProductDescriptionDocumentLinks />
      <AccordionStack>
        {activeSubstances.length > 0 || additiveSubstances.length > 0 ? (
          <Accordion defaultExpanded>
            <AccordionSummary>
              <FormattedMessage id="productAdditonalInfos.label.activeIngredients" />
            </AccordionSummary>
            <AccordionDetails>
              {activeSubstances.length > 0 ? (
                <ProductDescriptionIngredientsSection
                  header={
                    <FormattedMessage id="productAdditonalInfos.headline.activeSubstances" />
                  }
                  substances={activeSubstances}
                />
              ) : null}
              {additiveSubstances.length > 0 ? (
                <ProductDescriptionIngredientsSection
                  header={
                    <FormattedMessage id="productAdditonalInfos.headline.additiveSubstances" />
                  }
                  substances={additiveSubstances}
                />
              ) : null}
            </AccordionDetails>
          </Accordion>
        ) : null}

        {descriptionLongAndAdditionalInformation.length > 0 ? (
          <Accordion defaultExpanded>
            <AccordionSummary>
              <FormattedMessage id="productAdditonalInfos.label.furtherProductInformation" />
            </AccordionSummary>
            <AccordionDetails>
              <ProductDescriptionShowMore
                defaultOpen={productAccessorIsRxOrOtxTemplate(productTemplate)}
              >
                {descriptionLongAndAdditionalInformation.map((section) => (
                  <ProductDescriptionSection
                    key={section.content}
                    section={section}
                  />
                ))}
              </ProductDescriptionShowMore>
            </AccordionDetails>
          </Accordion>
        ) : null}
      </AccordionStack>
    </>
  )
}
